/* ========================================
   FILE: assets/pickup-availability.js
   VERSION: Accordion Variant – 2025-11-06
   ======================================== */

function initPickupAvailability() {
  class PickupAvailability extends HTMLElement {
    constructor() {
      super();
      console.log('PickupAvailability: constructor called');

      // Load pickup data from <script data-pickup-data>
      this.pickupData = this.getPickupData();
      console.log('Pickup data loaded:', this.pickupData);

      // Initialize after a short delay (DOM rendering buffer)
      setTimeout(() => {
        this.init();
      }, 150);
    }

    init() {
      console.log('PickupAvailability: init started');
      this.setupAccordion();

      // Detect variant changes (Enterprise theme)
      const variantPicker = this.closest('.product-info')?.querySelector('variant-picker');
      if (variantPicker) {
        variantPicker.addEventListener('on:variant:change', this.handleVariantChange.bind(this));
        console.log('PickupAvailability: variant change listener attached');
      } else {
        console.warn('PickupAvailability: variant picker not found');
      }
    }

    /* ---------- Accordion Setup ---------- */
    setupAccordion() {
      const accordionHeaders = this.querySelectorAll('[data-accordion-toggle]');
      if (!accordionHeaders.length) {
        console.warn('PickupAvailability: No accordion headers found');
        return;
      }

      accordionHeaders.forEach(header => {
        header.addEventListener('click', e => {
          // Ignore clicks on links
          if (e.target.classList.contains('pickup-accordion-store-name')) return;

          const item = header.closest('.pickup-accordion-item');
          const content = item.querySelector('.pickup-accordion-content');
          const chevron = header.querySelector('.pickup-accordion-chevron');
          const isOpen = content.classList.contains('is-open');

          if (isOpen) {
            content.classList.remove('is-open');
            chevron.classList.remove('is-open');
            header.classList.remove('is-open');
          } else {
            content.classList.add('is-open');
            chevron.classList.add('is-open');
            header.classList.add('is-open');
          }
        });
      });

      console.log('PickupAvailability: Accordion setup complete');
    }

    /* ---------- Get pickup data ---------- */
    getPickupData() {
      const dataEl = this.querySelector('script[data-pickup-data]');
      if (!dataEl) {
        console.error('PickupAvailability: data script not found');
        return null;
      }

      try {
        return JSON.parse(dataEl.textContent);
      } catch (err) {
        console.error('PickupAvailability: JSON parse error', err);
        return null;
      }
    }

    /* ---------- Handle variant changes ---------- */
    handleVariantChange(evt) {
      console.log('PickupAvailability: Variant changed', evt.detail);
      if (!evt.detail?.variant || !this.pickupData) return;

      const variantId = evt.detail.variant.id.toString();
      const variantData = this.pickupData.variants[variantId];

      if (variantData) {
        this.updatePickupStatus('melbourne', variantData.melbourne);
        this.updatePickupStatus('sydney', variantData.sydney);
      } else {
        console.warn(`PickupAvailability: No pickup data for variant ${variantId}`);
      }
    }

    /* ---------- Update per location ---------- */
    updatePickupStatus(location, inStock) {
      const accordionItem = this.querySelector(`.pickup-${location}`);
      if (!accordionItem) {
        console.warn(`PickupAvailability: accordion item not found for ${location}`);
        return;
      }

      console.log(`PickupAvailability: Updating ${location} inStock=${inStock}`);
      const badge = accordionItem.querySelector('.pickup-status-badge');
      const statusText = accordionItem.querySelector('.pickup-status-text');

      if (badge) {
        badge.textContent = inStock ? 'In Stock' : 'Out of Stock';
        badge.classList.toggle('in-stock', inStock);
        badge.classList.toggle('out-of-stock', !inStock);
      }

      if (statusText) {
        if (inStock) {
          statusText.textContent = 'In Stock, Pickup Available.';
          statusText.style.color = '#28a745';
        } else if (this.pickupData.preOrder) {
          statusText.textContent = 'Out of Stock. Place a Pre-Order';
          statusText.style.color = '#007bff';
        } else {
          statusText.textContent = 'Out of Stock. Place a Backorder';
          statusText.style.color = '#dc3545';
        }
      }
    }

    /* ---------- Manual update if needed ---------- */
    fetchAvailability(variantId) {
      console.log('PickupAvailability: fetchAvailability for variant', variantId);
      if (!this.pickupData) return;

      const variantData = this.pickupData.variants[variantId.toString()];
      if (variantData) {
        this.updatePickupStatus('melbourne', variantData.melbourne);
        this.updatePickupStatus('sydney', variantData.sydney);
      }
    }
  }

  /* ---------- Register / upgrade component ---------- */
  if (customElements.get('pickup-availability')) {
    console.log('PickupAvailability: Upgrading existing elements');
    document.querySelectorAll('pickup-availability').forEach(el => {
      const newEl = new PickupAvailability();
      Array.from(el.attributes).forEach(attr => newEl.setAttribute(attr.name, attr.value));
      newEl.innerHTML = el.innerHTML;
      el.parentNode.replaceChild(newEl, el);
    });
  } else {
    customElements.define('pickup-availability', PickupAvailability);
  }
}

/* ---------- Shopify & DOM ready listeners ---------- */
document.addEventListener('DOMContentLoaded', () => {
  initPickupAvailability();
});

document.addEventListener('shopify:section:load', () => {
  initPickupAvailability();
});